import { useTranslation } from 'react-i18next';
import { InfluencerPostSection, InfluencerNewProfileHeaderV2 } from '@anytag/graphql';
import { chatGreenImage, networkBlueImage, likePinkImage, videoPinkImage } from '@anytag/shared-assets';
import { ChartsContainer } from '@anytag/shared-atoms';
import { PostingHabits, AverageEngagement } from '@anytag/shared-molecules';
import { useInfluencerProfileOpacityContent } from '../../../hooks';
import { InfluencerSelectedAccountInfo } from '../../../types';
import { InfluencerProfilePostsOverviewWrapper } from '../../shared';

interface InfluencerFacebookProfilePostsOverviewProps {
  data?: InfluencerPostSection;
  socialAccount: InfluencerSelectedAccountInfo;
  influencerProfile: InfluencerNewProfileHeaderV2;
}

export const InfluencerFacebookProfilePostsOverview = ({
  data,
  socialAccount,
  influencerProfile: { id }
}: InfluencerFacebookProfilePostsOverviewProps) => {
  const { t } = useTranslation();
  const { opacityContent } = useInfluencerProfileOpacityContent({
    socialAccount,
    influencerId: id,
    skipEstimateContent: true
  });

  return (
    <InfluencerProfilePostsOverviewWrapper data={data}>
      <ChartsContainer
        css={{ height: '324px' }}
        elements={[
          <AverageEngagement
            data={[
              {
                icon: videoPinkImage,
                label: t('Avg posts/week'),
                value: data?.averagePostsPerWeek || null
              },
              {
                icon: likePinkImage,
                value: data?.averageReactions || null,
                label: t('Avg Reaction/latest 30 posts')
              },
              {
                icon: chatGreenImage,
                value: data?.averageComments || null,
                label: t('Avg Comments/latest 30 posts')
              },
              {
                icon: networkBlueImage,
                value: data?.averageShares || null,
                label: t('Avg Shares/latest 30 posts')
              }
            ]}
          />,
          <PostingHabits {...opacityContent} data={data?.postsHabit} />
        ]}
      />
    </InfluencerProfilePostsOverviewWrapper>
  );
};
